import type { FormSelectOption } from '@practium/ui';

export const DEFENSIVE_CLASS_OPTIONS: FormSelectOption[] = [
	{ value: 'Fungicida', label: 'Fungicida' },
	{ value: 'Inseticida', label: 'Inseticida' },
	{ value: 'Herbicida', label: 'Herbicida' },
	{ value: 'Acaricida', label: 'Acaricida' },
	{ value: 'Nematicida', label: 'Nematicida' },
];

export const APPLICATION_METHOD_OPTIONS: FormSelectOption[] = [
	{ value: 'foliar_spray', label: 'Pulverização foliar' },
	{ value: 'seed_treatment', label: 'Tratamento de sementes' },
	{ value: 'drench', label: 'Drench' },
	{ value: 'irrigation', label: 'Fertirrigação' }
];

// TODO: Remove after legacy defensive records with applicationForm "broad" are cleaned up in the backend.
export const LEGACY_DEFENSIVE_APPLICATION_METHOD_LABELS: Record<string, string> = {
	broad: 'Lanço',
};

export const CULTURE_OPTIONS: FormSelectOption[] = [
	{ value: 'Arábica', label: 'Arábica' },
	{ value: 'Robusta', label: 'Robusta' },
	{ value: 'Soja', label: 'Soja' },
	{ value: 'Milho', label: 'Milho' },
	{ value: 'Café', label: 'Café' },
	{ value: 'Algodão', label: 'Algodão' },
	{ value: 'Trigo', label: 'Trigo' },
];

export const NATURE_OPTIONS: FormSelectOption[] = [
	{ value: 'solid', label: 'Sólido' },
	{ value: 'liquid', label: 'Líquido' },
];

export const DOSE_UNIT_OPTIONS: FormSelectOption[] = [
	{ value: 'L/ha', label: 'L/ha' },
	{ value: 'mL/ha', label: 'mL/ha' },
	{ value: 'kg/ha', label: 'kg/ha' },
	{ value: 'g/ha', label: 'g/ha' },
];

export const DEFAULT_DEFENSIVE_FORM = {
	commercialName: '',
	manufacturerId: '',
	nature: '',
	activeIngredients: [{ name: '', concentration: '' }],
	class: [] as { class: string; group?: string }[],
	culture: [] as string[],
	applicationForm: [] as string[],
	dose: '',
	doseMeasurementUnit: 'L/ha',
	syrupVolume: '',
	commonPests: '',
} as const;
